import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="supplier-name-editor"
export default class extends Controller {
  static targets = ["displayMode", "editMode", "nameInput", "editForm"];
  static values = {
    supplierId: String,
    currentName: String,
  };

  connect() {
    console.log("SupplierNameEditor controller connected");
  }

  startEditing(event) {
    event.preventDefault();
    console.log("Starting edit mode");

    // Hide display mode, show edit mode
    this.displayModeTarget.classList.add("hidden");
    this.editModeTarget.classList.remove("hidden");

    // Focus and select the input text
    this.nameInputTarget.focus();
    this.nameInputTarget.select();
  }

  cancelEditing(event) {
    console.log("Canceling edit mode");

    // Reset the input value to original
    this.nameInputTarget.value = this.currentNameValue;

    // Hide edit mode, show display mode
    this.editModeTarget.classList.add("hidden");
    this.displayModeTarget.classList.remove("hidden");
  }

  handleWindowClick(event) {
    // Only cancel if edit mode is visible and the click is outside our component
    if (!this.editModeTarget.classList.contains("hidden")) {
      const clickedElement = event.target;
      const isInsideComponent = this.element.contains(clickedElement);

      if (!isInsideComponent) {
        console.log("Clicked outside component, canceling edit");
        this.cancelEditing(event);
      }
    }
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.editFormTarget.requestSubmit();
    } else if (event.key === "Escape") {
      event.preventDefault();
      this.cancelEditing(event);
    }
  }

  handleSubmit(event) {
    console.log("handleSubmit called - Form submitted", event.detail);
    console.log("Event type:", event.type);

    if (event.type === "submit") {
      // Regular submit event - just prevent default, let Turbo handle it
      console.log("Regular submit event, letting Turbo handle it");
      return;
    }

    // This is turbo:submit-end
    console.log("Success status:", event.detail.success);

    // Always update the display with the current input value and switch back to display mode
    // The server will handle the actual persistence
    this.currentNameValue = this.nameInputTarget.value;

    // Update the display text immediately for better UX
    const displayNameElement =
      this.displayModeTarget.querySelector("p.text-xl");
    if (displayNameElement) {
      displayNameElement.textContent = this.nameInputTarget.value;
    }

    // Switch back to display mode
    this.editModeTarget.classList.add("hidden");
    this.displayModeTarget.classList.remove("hidden");

    // Check the response status
    if (event.detail.success !== false) {
      console.log("Update successful");
      this.showSuccessFeedback();
    } else {
      console.log("Update failed");
      this.showErrorFeedback();
    }
  }

  showSuccessFeedback() {
    // Create a temporary success indicator
    const feedback = document.createElement("div");
    feedback.className = "text-xs text-success mt-1";
    feedback.textContent = "✓ Nom mis à jour";

    // Insert after the display mode
    this.displayModeTarget.appendChild(feedback);

    // Remove after 3 seconds
    setTimeout(() => {
      if (feedback.parentNode) {
        feedback.remove();
      }
    }, 3000);
  }

  showErrorFeedback() {
    // Create a temporary error indicator
    const feedback = document.createElement("div");
    feedback.className = "text-xs text-error mt-1";
    feedback.textContent = "✗ Erreur lors de la mise à jour";

    // Insert after the edit mode
    this.editModeTarget.appendChild(feedback);

    // Remove after 5 seconds
    setTimeout(() => {
      if (feedback.parentNode) {
        feedback.remove();
      }
    }, 5000);
  }
}
